import { createStoreEmitters } from '@empathyco/x-components';
import { relatedPromptsXStoreModule } from './module';

export const relatedPromptsEmitters = createStoreEmitters(relatedPromptsXStoreModule, {});
